import { baseTheme } from "@app/theme";

export const buttonGroupContainerStyle = {
  display: "flex",
  justifyContent: "end",
  gap: "10px",
  margin: "20px 0px 0px 0px",
  fontSize: "20px",
};
